import { ShieldCheck, TrendingUp, Landmark, GraduationCap, Car, Heart } from "lucide-react";

const items = [
  { icon: ShieldCheck, text: "Protección familiar" },
  { icon: TrendingUp, text: "Crecimiento indexado" },
  { icon: Landmark, text: "Retiros libres de impuestos" },
  { icon: GraduationCap, text: "Fondo universitario" },
  { icon: Car, text: "$50 de descuento en auto" },
  { icon: Heart, text: "Legado para tus hijos" },
];

export const Marquee = () => (
  <div className="bg-navy text-white overflow-hidden border-y border-white/10" data-testid="marquee-strip">
    <div className="marquee-track py-3">
      {[...items, ...items, ...items].map(({ icon: Icon, text }, i) => (
        <span key={i} className="flex items-center gap-2.5 px-8 text-sm font-semibold tracking-wide whitespace-nowrap">
          <Icon className="h-4 w-4 text-[var(--green-500)]" />
          {text}
          <span className="ml-6 h-1 w-1 rounded-full bg-white/40" />
        </span>
      ))}
    </div>
  </div>
);
